var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.529 249.193C290.02 226.117 304 194.701 304 160C304 89.406 246.594 32 176 32H144C73.406 32 16 89.406 16 160C16 194.701 29.98 226.117 52.471 249.193C20.818 272.516 0 309.744 0 352C0 422.594 57.406 480 128 480H192C262.594 480 320 422.594 320 352C320 309.744 299.182 272.516 267.529 249.193ZM144 96H176C211.281 96 240 124.719 240 160S211.281 224 176 224H144C108.719 224 80 195.281 80 160S108.719 96 144 96ZM192 416H128C92.719 416 64 387.281 64 352S92.719 288 128 288H192C227.281 288 256 316.719 256 352S227.281 416 192 416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.5ee16c4855cd4193c1494538fe2df14b.svg";
export { ForwardRef as ReactComponent };